import React from "react";
import "../assets/css/footer.css";
import logo from "../assets/images/logo/logo.png";
import Ganesh from "../assets/images/footer-ganesh.png";
import logoDark from "../assets/images/logo/logoDark.png";
import { Link } from "react-router-dom";
import Icon from "../components/Icon";
import {
  faEnvelope,
  faLocationDot,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import useWidth from "../hooks/useWidth";

import fb from '../assets/images/fb.svg'
import twitter from '../assets/images/twitter.svg'
import insta from '../assets/images/instagram.svg'

const Footer = () => {
  const width = useWidth();
  return (
    <>
      {width > 992 ? (
        <div className="footer">
          <div className=" bottom-menu ">
            <div className="d-flex justify-content-center">
                <img src={Ganesh} style={{ width: "300px" }} />
            </div>
            <div
              className="row align-items-bottom m-0"
              style={{ paddingTop: "175px" }}
            >
              <div className="col-6 d-flex">
                <div className="bottom-logo">
                  <img src={logo} alt="" className="w-100 h-100" />
                </div>
                <div className="">
                  <h4 className="mb-0 text-light discover">
                    Discover
                    <br />
                    Learn
                    <br />
                    Immerse
                  </h4>
                </div>
              </div>
              <div className="col-3">
                <h5 className="text-light">Links</h5>
                <ul className="list-unstyled">
                  <li>
                    <Link to={'/privacy-policy'}>Privacy Policy</Link>
                  </li>
                  <li>
                    <Link to={'/terms-of-service'}>Terms Of Service</Link>
                  </li>

                  <li>
                    <Link to={'/cookies-policy'}>Cookies Policy</Link>
                  </li>
                </ul>
              </div>
              <div className="col-3">
                <h5 className="text-light">Contact Us</h5>

                <ul className="list-unstyled">
                  <li>
                    <div className="d-flex">
                      <Icon icon={faLocationDot} className="text-light mt-1" />
                      <p
                        className="text-light mb-1"
                        style={{ marginLeft: "10px" }}
                      >
                        44 Backary Portion, Level 2 Regal Building,
                        <br />
                        Hanuman Road Area, Cannaught Place, New Delhi-110001
                      </p>
                    </div>
                  </li>
                  <li>
                    <div className="d-flex">
                      <Icon icon={faPhone} className="text-light mt-1" />
                      <a
                        href="tel:+919910585869"
                        className="text-light mb-1 "
                        style={{ marginLeft: "10px" }}
                      >
                        +91 991-058-5869
                      </a>
                    </div>
                  </li>

                  <li>
                    <div className="d-flex">
                      <Icon icon={faEnvelope} className="text-light mt-1" />
                      <a
                        href="mailto:dham@gmail.com?subject=SUBJECT&body=Demo email" target="_blank"
                        className="text-light mb-1"
                        style={{ marginLeft: "10px" }}
                      >
                        dham@gmail.com
                      </a>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="bottom-text row m-0">
            <div className="col-4 d-flex align-items-center">
              <span className="ms-3 text-success">
                © 2024 Dham Pvt Ltd. All rights reserved.
              </span>
            </div>
            <div className="col-5"></div>
            <div className="col-3 ">
              <div className="d-flex justify-content-end align-items-center h-100">
                <ul className="list-unstyled d-flex  align-items-center m-0 gap-3 mx-4">
                  <li>
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{
                        width: "30px",
                        height: "30px",
                        background: "red",
                        borderRadius: "50%",
                      }}
                    ></div>
                  </li>

                  <li>
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{
                        width: "30px",
                        height: "30px",
                        background: "red",
                        borderRadius: "50%",
                      }}
                    ></div>
                  </li>

                  <li>
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{
                        width: "30px",
                        height: "30px",
                        background: "red",
                        borderRadius: "50%",
                      }}
                    ></div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="footer-mobile">
          <div className=" bottom-menu ">
            <div
              className="row align-items-bottom m-0"
              // style={{ paddingTop: "375px" }}
            >
              <div className="col-12 d-flex mt-5 justify-content-center">
                <div className="bottom-logo m-0">
                  <img src={logoDark} alt="" className="w-100 h-100" />
                </div>
                <div className="">
                  <h4 className="mb-0  discover" style={{ color: "#4a061b" }}>
                    Discover
                    <br />
                    Learn
                    <br />
                    Immerse
                  </h4>
                </div>
              </div>
              <div className="col-12">
                <h5 className="text-light">Links</h5>
                <ul className="list-unstyled">
                <li>
                    <Link to={'/privacy-policy'}>Privacy Policy</Link>
                  </li>
                  <li>
                    <Link to={'/terms-of-service'}>Terms Of Service</Link>
                  </li>

                  <li>
                    <Link to={'/cookies-policy'}>Cookies Policy</Link>
                  </li>
                </ul>
              </div>
              <div className="col-12">
                <div className="row mx-0">
                  <div className="col-10 p-0">
                    <h5 className="text-light mx-0">Contact Us</h5>

                    <ul className="list-unstyled m-0">
                      <li>
                        <div className="d-flex">
                          <Icon
                            icon={faLocationDot}
                            className="text-light mt-1"
                          />
                          <p
                            className="text-light mb-1"
                            style={{ marginLeft: "10px" }}
                          >
                            Akshya Nagar 1st Block 1st Cross,
                            <br />
                            Rammurthy nagar, Bangalore-560016
                          </p>
                        </div>
                      </li>
                      <li>
                        <div className="d-flex">
                          <Icon icon={faPhone} className="text-light mt-1" />
                          <p
                            className="text-light mb-1 "
                            style={{ marginLeft: "10px" }}
                          >
                            +91 1234567890
                          </p>
                        </div>
                      </li>

                      <li>
                        <div className="d-flex">
                          <Icon icon={faEnvelope} className="text-light mt-1" />
                          <p
                            className="text-light mb-1"
                            style={{ marginLeft: "10px" }}
                          >
                            Dham@gmail.com
                          </p>
                        </div>
                      </li>
                    </ul>
                  </div>

                  <div className="col-2">
                    <ul className="list-unstyled ">
                      <li className="mt-2">
                        <div
                          className="d-flex justify-content-center align-items-center"
                          style={{ width: "23px", height: "23px" , background:"#3a86ff", padding:"3px", borderRadius:"50%"}}
                        >
                          <img src={twitter} className="w-100 h-100" alt="" />
                        </div>
                      </li>

                      <li className="mt-2">
                        <div
                          className="d-flex justify-content-center align-items-center"
                          style={{ width: "23px", height: "23px" , background:"#3a86ff", padding:"5px",  borderRadius:"50%"}}
                        >
                          <img src={insta} className="w-100 h-100" alt="" />
                        </div>
                      </li>

                      <li className="mt-2">
                        <div
                          className="d-flex justify-content-center align-items-center"
                          style={{ width: "23px", height: "23px" , background:"#3a86ff", padding:"3px",  borderRadius:"50%"}}
                        >
                          <img src={fb} className="w-100 h-100" alt="" />
                        </div>
                      </li>
                      
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-12 d-flex align-items-center mt-5" style={{ marginBottom: "50px"}}>
                <span className="text-info">
                  © 2024 Dham Pvt Ltd. All rights reserved.
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Footer;
